module.exports = __webpack_public_path__ + "img/50-king.abd78dba.svg";